import { Injectable, inject, signal } from '@angular/core';
import { BankIntegrationService } from './bank-integration.service';

/**
 * Bekleyen banka akışı kaydı sayısını paylaşan hafif durum servisi. Hem kenar çubuğu
 * rozeti hem de inceleme kutusu sayfası enjekte eder; böylece Post/Ignore sonrası rozet
 * anında güncellenir (yeniden istek atmadan).
 */
@Injectable({ providedIn: 'root' })
export class BankFeedBadgeService {
  private readonly svc = inject(BankIntegrationService);

  readonly pendingCount = signal(0);

  refresh(): void {
    this.svc.getPendingReviewCount().subscribe({
      next: (count) => this.pendingCount.set(count),
      error: () => this.pendingCount.set(0),
    });
  }

  decrement(): void {
    this.pendingCount.update((count) => Math.max(0, count - 1));
  }
}
